import * as tslib_1 from "tslib";
import { settings } from '../../../settings';
import { RailPackageServiceActionTypes } from './types';
var coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
export function getRailPackageGroups(railPackageGroupRequest, storageKey) {
    var _this = this;
    if (storageKey === void 0) { storageKey = 'default'; }
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var protocol, apiEndpoint, result, res, response, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    protocol = getState().app.location.protocol;
                    apiEndpoint = settings.coreApi.endPoints.railPackage.base + settings.coreApi.endPoints.railPackage.groups;
                    dispatch({
                        type: RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_GROUPS
                    });
                    result = {
                        storageKey: storageKey,
                        type: RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_GROUPS_RESPONSE,
                        groups: {}
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
                            method: 'POST',
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: settings.coreApi.defaultPostHeaders,
                            body: JSON.stringify(railPackageGroupRequest)
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    result.groups = response;
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 5: return [2 /*return*/, dispatch(result)];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
export function getRailPackageOffers(railPackageOfferRequest, storageKey) {
    var _this = this;
    if (storageKey === void 0) { storageKey = 'default'; }
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var protocol, apiEndpoint, result, res, response, error_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    protocol = getState().app.location.protocol;
                    apiEndpoint = settings.coreApi.endPoints.railPackage.base + settings.coreApi.endPoints.railPackage.offers;
                    dispatch({
                        type: RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_OFFERS
                    });
                    result = {
                        storageKey: storageKey,
                        type: RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_OFFERS_RESPONSE,
                        offers: {}
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
                            method: 'POST',
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: settings.coreApi.defaultPostHeaders,
                            body: JSON.stringify(railPackageOfferRequest)
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    result.offers = response;
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 6];
                case 5: return [2 /*return*/, dispatch(result)];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
export function getRailPackageProducts(railPackageProductRequest, storageKey) {
    var _this = this;
    if (storageKey === void 0) { storageKey = 'default'; }
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var protocol, apiEndpoint, result, res, response, error_3;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    protocol = getState().websiteState.app.location.protocol;
                    apiEndpoint = settings.coreApi.endPoints.railPackage.base + settings.coreApi.endPoints.railPackage.products;
                    dispatch({
                        storageKey: storageKey,
                        type: RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_PRODUCTS
                    });
                    result = {
                        storageKey: storageKey,
                        type: RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_PRODUCTS_RESPONSE,
                        products: {}
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
                            method: 'POST',
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: settings.coreApi.defaultPostHeaders,
                            body: JSON.stringify(railPackageProductRequest)
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    result.products = response;
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 6];
                case 5: return [2 /*return*/, dispatch(result)];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
export function getRailPackageVariants(railPackageVariantRequest, storageKey) {
    var _this = this;
    if (storageKey === void 0) { storageKey = 'default'; }
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var protocol, apiEndpoint, result, res, response, error_4;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    protocol = getState().app.location.protocol;
                    apiEndpoint = settings.coreApi.endPoints.railPackage.base + settings.coreApi.endPoints.railPackage.variants;
                    dispatch({
                        type: RailPackageServiceActionTypes.REQUEST_RAIL_PACKAGE_VARIANTS
                    });
                    result = {
                        storageKey: storageKey,
                        type: RailPackageServiceActionTypes.RECEIVE_RAIL_PACKAGE_VARIANTS_RESPONSE,
                        variants: {}
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + apiEndpoint, {
                            method: 'POST',
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: settings.coreApi.defaultPostHeaders,
                            body: JSON.stringify(railPackageVariantRequest)
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    result.variants = response;
                    return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 6];
                case 5: return [2 /*return*/, dispatch(result)];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
